import { render, staticRenderFns } from "./select-language.vue?vue&type=template&id=ee145188&"
import script from "./select-language.vue?vue&type=script&lang=js&"
export * from "./select-language.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports